export enum HideStrategy {
  EXPECTED_WAITING_TIME = 'expected_waiting_time',
  ALL_AGENTS_AWAY = 'all_agents_away',
  ALL_AGENTS_OFFLINE = 'all_agents_offline',
  NEVER = 'never',
}

export type Views = 'sticky' | 'badge';

export type ViewTypes = 'minimized_view' | 'chatbox_view';

export type Positions = 'bottom_left' | 'bottom_right' | 'left' | 'right';

export type PositionLabelsT =
  | 'Bottom right'
  | 'Bottom left'
  | 'Top right'
  | 'Top left';

export type LocalizationsT =
  | 'cs-CZ'
  | 'da'
  | 'de-DE'
  | 'el-GR'
  | 'en-US'
  | 'es-ES'
  | 'et-EE'
  | 'fi'
  | 'fr-FR'
  | 'hi-IN'
  | 'hr-HR'
  | 'hu-HU'
  | 'id-ID'
  | 'is'
  | 'it-IT'
  | 'ja-JP'
  | 'ko-KR'
  | 'lt-LT'
  | 'lv-LV'
  | 'ms-MY'
  | 'nl'
  | 'no'
  | 'pl-PL'
  | 'pt-PT'
  | 'ro-RO'
  | 'ru-RU'
  | 'sv'
  | 'th-TH'
  | 'tr-TR'
  | 'vi-VN'
  | 'zh-CN'
  | 'ar';

export type LocalizationLabelsT =
  | 'Arabic'
  | 'Bahasa Indonesia'
  | 'Bahasa Malay'
  | 'Chinese Mandarin'
  | 'Croatian'
  | 'Czech'
  | 'Danish'
  | 'Dutch'
  | 'English'
  | 'Estonian'
  | 'Finnish'
  | 'French'
  | 'German'
  | 'Greek'
  | 'Hindi'
  | 'Hungarian'
  | 'Icelandic'
  | 'Italian'
  | 'Japanese'
  | 'Korean'
  | 'Latvian'
  | 'Lithuanian'
  | 'Norwegian'
  | 'Polish'
  | 'Portuguese'
  | 'Romanian'
  | 'Russian'
  | 'Spanish'
  | 'Swedish'
  | 'Thai'
  | 'Turkish'
  | 'Vietnamese';
